import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { cn } from "helper/Utils";
import { useAuth } from "provider/AuthContext";
import { useSportsbook } from "provider/SportsbookContext";

export const UserActionsDropdown = ({ label, toggleBtnClasses, menuItemsClasses, menuData, handleUserSettingMenuItemClick, dropdownType }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { sendMessageToSportsbook } = useSportsbook();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const openMenu = (event) => {
    setIsOpen(true);
    if (event.currentTarget) {
      event.currentTarget.click();
    } else {
      console.error("No currentTarget found.");
    }
  };
  const closeMenu = () => setIsOpen(false);
  return (
    <Menu
      as="li"
      className="relative before:rounded-se before:rounded-ss hover:before:content-[''] hover:before:h-[2px] hover:before:w-full hover:before:absolute hover:before:top-0 hover:before:left-0 hover:before:bg-primary"
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
    >
      {({ open }) => (
        <>
          <MenuButton
            role="button"
            onMouseEnter={(event) => openMenu(event)}
            className={cn("text-white min-h-[28px] py-1 px-2 rounded text-[12px] flex items-center", toggleBtnClasses)}
          >
            {label}
          </MenuButton>
          {isOpen && (
            <MenuItems
              transition
              anchor="bottom end"
              className={cn(
                "origin-top focus-within:outline-0 bg-[rgb(0,12,36,1)] min-w-[235px] p-2 transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 z-[100]",
                menuItemsClasses
              )}
            >
              {menuData.map((item, index) => (
                <MenuItem
                  key={index}
                  as="button"
                  onClick={() => handleUserSettingMenuItemClick(item)}
                  className="menu-item-bg-gradiant w-full list-none mt-0.5 pl-3 rounded-[4px] flex cursor-pointer items-center relative before:rounded-tl-lg before:rounded-bl-lg hover:before:h-full hover:before:w-0.5 hover:before:bg-primary hover:before:absolute hover:before:left-0 group"
                >
                  {typeof item.icon === "string" && item.icon.startsWith("bc-i") ? (
                    <i className={`text-white/70 text-[17px] group-hover:text-white ${item.icon}`} />
                  ) : (
                    <span className="text-white/70 text-[17px] group-hover:text-white">{item.icon}</span>
                  )}

                  <span className="flex items-center text-[14px] ml-2 h-[34px] text-white/70 group-hover:text-white data-[focus]:bg-blue-100">
                    {item.label}
                  </span>
                </MenuItem>
              ))}
              {dropdownType === "user" && (
                <MenuItem
                  as="button"
                  className=" w-full list-none rounded-[4px] pl-3 bg-[rgb(255,255,255,0.15)] hover:bg-[rgb(255,255,255,0.35)] h-[32px] flex cursor-pointer items-center !mt-2"
                  onClick={() => {
                    sendMessageToSportsbook({ logout: "" });
                    logout();
                    navigate("/");
                  }}
                >
                  <i className="text-white/70 text-[16px] bc-i-logout"></i>
                  <span className="text-white/70 block text-[12px] ml-2 data-[focus]:bg-blue-100 uppercase">{t("logout")}</span>
                </MenuItem>
              )}
            </MenuItems>
          )}
        </>
      )}
    </Menu>
  );
};
